class GraphicUploadActionType {
    static graphicUploadSubmit = {
        start: 'COMPONENT_GRAPHIC_UPLOAD_SUBMIT_START',
        success: 'COMPONENT_GRAPHIC_UPLOAD_SUBMIT_SUCCESS',
        fail: 'COMPONENT_GRAPHIC_UPLOAD_SUBMIT_FAIL',
        reset: 'COMPONENT_GRAPHIC_UPLOAD_SUBMIT_RESET',
        setFileCount: 'COMPONENT_GRAPHIC_UPLOAD_SUBMIT_SET_FILE_COUNT',
    };

    static graphicUploadDelete = {
        start: 'COMPONENT_GRAPHIC_UPLOAD_DELETE_START',
        success: 'COMPONENT_GRAPHIC_UPLOAD_DELETE_SUCCESS',
        fail: 'COMPONENT_GRAPHIC_UPLOAD_DELETE_FAIL',
    };

    static graphicUploadConsent = {
        accept: 'COMPONENT_GRAPHIC_UPLOAD_CONSENT_ACCEPT',
    };
}

export default GraphicUploadActionType;
